
const Pricing = () => {
  return null;
};

export default Pricing;
